import { Component, DestroyRef, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { API, DeviceFullDTO } from 'src/app/services/api/api';
import { ErrorService } from 'src/app/services/error.service';
import { UtilService } from 'src/app/services/util.service';
import { PermissionService } from '../../../../services/permission.service';
import { finalize, take } from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-device-details-attributes',
  templateUrl: './device-details-attributes.component.html',
  styleUrls: ['./device-details-attributes.component.scss'],
  standalone: false,
})
export class DeviceDetailsAttributesComponent implements OnInit {
  deviceId: number;
  device: DeviceFullDTO;
  loading: boolean;

  constructor(
    private api: API,
    private activatedRoute: ActivatedRoute,
    public util: UtilService,
    public errorHandler: ErrorService,
    public permissionService: PermissionService,
    private destroyRef: DestroyRef
  ) {
    this.loading = true;
    this.device = null;
    this.deviceId = null;
  }

  ngOnInit() {
    this.activatedRoute.parent.params.subscribe(params => {
      this.deviceId = +params.deviceID;
      this.refresh();
    });
  }

  refresh() {
    this.loading = true;
    if (this.deviceId) {
      this.api
        .ss_nm_Device_retrieveFullById(this.deviceId)
        .pipe(
          takeUntilDestroyed(this.destroyRef),
          take(1),
          finalize(() => {
            this.loading = false;
          })
        )
        .subscribe({
          next: (e: DeviceFullDTO) => {
            this.device = e;
          },
          error: error => {
            if (!error.status || !(+error.status === 403 || +error.status === 404)) {
              this.errorHandler.errorHandler(error);
            }
          },
        });
    }
  }
}
